import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        openButton: {
            display: 'flex',
            flexDir: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            height: remCalc(32),
            borderRadius: 'large',
            width: 'fit-content',
            paddingX: 'xxsmall.xl',
            paddingY: 'xxxsmall-1.xl',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-footer) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            _before: {
                content: '""',
                position: 'absolute',
                bg: 'border.neutral.footer',
                inset: 0,
                opacity: 0.2,
                borderRadius: 'large',
                boxShadow:
                    '0 0 0 1px var(--chakra-colors-border-neutral-footer) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            },
        },
        selectorSubContainer: {
            zIndex: 1,
            height: 'auto',
            gap: {
                base: 'xxxsmall.base',
                md: 'xxxsmall.md',
                lg: 'xxxsmall.lg',
                xl: 'xxxsmall.xl',
            },
            width: 'max-content',
            alignItems: 'flex-start',
        },
        countrySvgContainer: {
            width: remCalc(16),
            height: remCalc(16),
            borderRadius: '50%',
            overflow: 'hidden',
            justifyContent: 'center',
            alignItems: 'center',
        },
        buttonText: {
            color: 'foreground.neutral.inverse',
            textAlign: 'center',
            textStyle: 'body-small',
            fontWeight: 'medium',
            paddingX: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
        },
        buttonArrow: {
            boxSize: 'iconsSize.small',
            color: 'white',
        },
        modalContainer: {
            size: 'full',
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: remCalc(10),
        },
        modalBody: {
            paddingY: 'small.xl',
            paddingX: 0,
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: 'medium-1.xl',
        },
        selectorContent: {
            paddingX: {
                base: 'xsmall.base',
                md: 'xsmall.md',
                lg: 'xsmall.lg',
                xl: 'xsmall.xl',
            },
            marginTop: remCalc(4),
            marginBottom: remCalc(4),
            marginLeft: {base: remCalc(4), lg: remCalc(768)},
            marginRight: remCalc(4),
            maxWidth: remCalc(740),
            borderRadius: 'large-1',
            bg: 'background.base.default',
        },
        selectorHeader: {
            display: 'flex',
            flexDir: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 'xsmall.xl',
            width: '100%',
            paddingY: 'small.xl',
            paddingX: 'xxsmall.xl',
        },
        headerTextContainer: {
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
        },
        headerText: {
            alignSelf: 'flex-start',
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        headerSubtitleContainer: {
            flexDir: 'row',
            alignItems: 'center',
            gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
        },
        headerSubtitle: {
            display: {base: 'block', md: 'flex'},
            gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
            alignSelf: 'flex-start',
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'foreground.neutral.muted',
        },
        headerSubtitleButton: {
            height: remCalc(17.92),
            marginY: 0,
            textStyle: 'body-small',
            fontWeight: 'medium',
            textDecoration: 'underline',

            _hover: {
                textDecoration: 'underline',
                color: 'foreground.neutral.default',
            },
        },
        closeIcon: {
            h: remCalc(16),
            w: remCalc(16),
            color: 'foreground.neutral.default',
        },
        countryButton: {
            w: remCalc(168),
            height: 'auto',
            display: 'flex',
            flexDir: 'row',
            gap: 'xxsmall.xl',
            alignItems: 'center',
            justifyContent: 'flex-start',
            paddingX: 'xxsmall-1.xl',
            paddingY: 'xxsmall.xl',
        },
        countryContainer: {
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 'medium',
            w: remCalc(32),
            h: remCalc(32),
            flexShrink: 0,
            bg: 'background.base.default',
            boxShadow:
                '0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 1px var(--neutral-xs, rgba(19, 24, 58, 0.08))',
        },
        countryVStack: {
            flex: 1,
            minWidth: 0,
            gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
            alignItems: 'flex-start',
            justifyContent: 'center',
        },
        region: {
            display: 'flex',
            flexDir: 'column',
            justifyContent: 'flex-start',
            paddingX: 0,
        },
        flag: {
            width: remCalc(36),
            height: remCalc(27),
            flexShrink: '0',
        },
        textHeader: {
            color: 'foreground.neutral.default',
            textStyle: 'head-large',
            fontFamily: 'heading',
            fontWeight: 'light',
            padding: 'xxsmall.xl',
        },
        textFooterHeader: {
            color: 'foreground.neutral.default',
            textStyle: 'head-large',
            fontFamily: 'heading',
            fontWeight: 'light',
        },
        textCountry: {
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'normal',
            width: '100%',
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            noOfLines: 2,
        },
        textCode: {
            color: 'foreground.neutral.subtle',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        selectorGrid: {
            marginTop: 'xsmall-1.xl',
            gridTemplateColumns: {
                base: `repeat(2, minmax(${remCalc(168)}, 1fr))`,
                md: `repeat(4, minmax(${remCalc(168)}, 1fr))`,
            },
            gridColumnGap: 'xxsmall-1.xl',
            gridRowGap: 'xxsmall-1.xl',
        },
        selectorFooter: {
            paddingY: remCalc(24),
            paddingX: 0,
            display: 'flex',
            flexDir: 'row',
            justifyContent: 'flex-start',
            alingItems: 'flex-start',
            gap: remCalc(16),
        },
        footerContent: {
            display: 'flex',
            width: remCalc(331),
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: 'xsmall.xl',
        },
        footerText: {
            color: 'foreground.neutral.subtle',
            textStyle: 'body-large',
            fontWeight: 'normal',
        },
        accordionItem: {
            borderTop: 'none',
            borderBottomWidth: remCalc(0.5),
            padding: remCalc(24),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        accordionButton: {
            alignItems: 'center',
        },
        accordionIcon: {
            color: 'background.dark',
            boxSize: 'iconsSize.large',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        websiteIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.inverse',
        },
    },
}
